// extracted by mini-css-extract-plugin
module.exports = {"rotation":"ConfrontaProdottiTemplate_rotation__7yaiU"};